/**
 * Builds a lookup of helper subfields per MARC tag from a FormConfig.
 * A subfield is "helper" if it is `hidden` and has a `defaultValue`
 * (e.g., `024 $2='isni'`, `370 $2='czenas'`, `510 $w='a'`).
 */
export function buildHiddenSubfieldLookup(config) {
    var lookup = new Map();
    for (var _i = 0, _a = config.tabs; _i < _a.length; _i++) {
        var tab = _a[_i];
        for (var _b = 0, _c = tab.fields; _b < _c.length; _b++) {
            var field = _c[_b];
            if (!lookup.has(field.tag)) {
                lookup.set(field.tag, new Set());
            }
            var codes = lookup.get(field.tag);
            for (var _d = 0, _e = field.subfields; _d < _e.length; _d++) {
                var sf = _e[_d];
                if (sf.hidden && sf.defaultValue !== undefined) {
                    codes.add(sf.code);
                }
            }
        }
    }
    return lookup;
}
export function instanceHasContent(fieldTag, subfields, hiddenLookup) {
    // Tags not configured in FormConfig: keep (safe default — could be added by
    // import or future schema).
    if (!hiddenLookup.has(fieldTag)) {
        return true;
    }
    var hiddenCodes = hiddenLookup.get(fieldTag);
    return subfields.some(function (sf) {
        if (hiddenCodes.has(sf.subfieldCode)) {
            return false;
        }
        if (sf.value && sf.value.trim().length > 0) {
            return true;
        }
        // Defensive fallback for component-backed subfields. In normal flow
        // computeSummarizedValue populates `value` whenever any component is
        // non-blank, so this branch is unreachable; we still check it so a
        // bug elsewhere can't cause a content-bearing instance to be dropped.
        if (sf.components && sf.components.some(function (c) { return c.value && c.value.trim().length > 0; })) {
            return true;
        }
        return false;
    });
}
